import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faUserCog
}
    from "@fortawesome/free-solid-svg-icons";

import './Sidebar.css';
import AcreLogo from '../../res/acrelogo.svg';

class Sidebar extends React.Component {

    render() {
        return (
            <nav
                className={this.props.toggle === true ? "sidebar toggled" : "sidebar"}>
                <div className="sidebar-content">
                    <Link className="sidebar-brand-logo" to="/">
                        <span className="align-middle">Acre Group</span>
                    </Link>
                    <div className="sidebar-user-container">
                        <img src={AcreLogo} alt="Acre Logo" />
                        {/* <div className="font-weight-bold">Hoşgeldiniz</div> */}
                    </div>
                    <ul className="sidebar-navigator">
                        <li>
                            <Link
                                className="sidebar-link"
                                to="/login">
                                <FontAwesomeIcon icon={faUserCog} fixedWidth color="#92172E" className="align-middle mrt-1" />
                                <span
                                    className="align-middle"
                                >Admin Dashboard</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        )
    }
}

export default Sidebar